<template>
  <div class="container-fluid footer pt-5 zIndex22">
    <div class="row justify-content-center Medium ">
      <div class="col-lg-12 center">
        <p>
          Laboratoire Native Italia S.p.A. a socio unico - Largo Augusto, 8 - 20122 Milano -
          Codice Fiscale, Partita IVA e Registro Imprese di Milano n.
          11618450156 REA n. MI-1481980 – Tutti i diritti sono riservati<br />
        </p>
        <p>
          Servizio Clienti disponibile dal Lunedì al Venerdì nei seguenti orari:
          8.00- 12/ 13 - 17 00.
        </p>
        <p>
          Numero <a href="tel:0290390441">0290390441</a> Oppure manda una mail
          a:
          <a href="mailto:promozioninative@edps.it">promozioninative@edps.it</a>
        </p>
      </div>
      <div class="col-lg-3  text-center">
        <p class="center">
          <a
            class="center"
            href="https://it.lierac.com/cms/note-legali"
            target="_blank"
            >Privacy e cookie policy</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
const moment = require("moment");

export default {
  name: "sqreen-footer",
  data() {
    return {
      year: moment().year()
    };
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "loadingState",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
      "checkAge"
    ]),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  }
};
</script>

<style lang="css" scoped>
.footerText {
  font-size: 16px;
  margin-bottom: 0px;
  color: #fffbde;
}

.footerBrownDesc {
  color: #000000;
  font-family: museo-slab;
  font-size: 16px;
}

.footerImageRight {
  text-align: right;
}

.support {
  color: #000000;
  font-size: 16px;
}

.techImage {
  width: 90%;
}

.tech {
  position: absolute;
  top: -80px;
  left: -80px;
  font-size: small;
}

.bottomBrand {
  padding: 28px;
}

@media (min-width: 20px) and (max-width: 767px) {
  .footerImageRight {
    text-align: left;
  }
  .footerText {
    font-size: 14px;
    margin-top: 10px;
  }
  .tech {
    top: -100px;
  }

  .bottomBrand {
    width: 27vw;
    padding-top: 10px;
    padding: 10px;
  }

  .footer {
    /*margin-top: -200px!important;*/
    height: 230px !important;
  }

  .alignBottomMobile {
    align-self: flex-end;
  }

  .techImage {
    width: 59%;
  }

  .tech {
    top: -60px;
    left: -57px;
    width: 172px;
  }

  .footerBrownDesc[data-v-62fe346e] {
    color: #000000;
    font-family: museo-slab;
    font-size: 13px;
  }

  .support[data-v-62fe346e] {
    color: #000000;
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue